import { Box, Button, Dialog, Grid, Typography } from '@mui/material';
import 'index.css';
import React, { useState, useEffect } from 'react';
import { poppins500, poppins700 } from 'theme/common.style';
import DecreasingCounter from './DecreasingCounter';
import Spinner from './Spinner';
import Loading from 'assets/images/loading.png';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { Warning } from 'component/BuyersMarketplace/MakeOffers';
import { Sign } from 'component/BuyersMarketplace/MakeOffers';
import {
  AdditionalIcon,
  SubDueDiliIcon,
  SubContractIcon,
  SubFinIcon,
  DepIcon,
  SettleIcon,
} from './Marketplaceicons';
import AdditionalConditionTooltip from 'component/Common/AdditionalConditionTooltip';

const SubmitOfferPopup = ({
  openCard,
  setOpenCard,
  openBox,
  setOpenBox,
  isLoading,
  isLoader,
  stage,
  groupCall,
  groupIt,
  matchessm,
  matchesmd,
  isSmallHeight,
  setIsLoading,
  setIsLoader,
  array,
  getBuyerIndividualValue,
  userDetail,
  totalAmount,
  formatTime,
  currentTime,
  formatDate,
  showTick,
  setShowTick,
  makeOffer,
  confirmCancel,
  setConfirmCancel,
  setAcceptterms,
  setOfferExp,
  setIsBestOffer,
  setSelectedItems,
  setIsAutoOffer,
  setTotalAmount,
  setMaximumOffer,
  setOfferIncreament,
  setSubtoAddSelected,
  setSelectedConditionCodes,
  selectedConditionCodes,
  addictionComment,
  settlementDays,
  depositAmount,
  conditional,
  offersOnly,
  setOffersOnly,
  makeOfferresponse,
  settleDays,
  depAmount,
  formatDateTimeSydney,
}) => {
  const [initialOfferStatus, setInitialOfferStatus] = useState(null);

  useEffect(() => {
    if (
      openCard &&
      initialOfferStatus == null &&
      array?.isFirstOffer != undefined
    ) {
      setInitialOfferStatus(array.isFirstOffer);
    }
    if (!openCard) {
      setInitialOfferStatus(null);
    }
  }, [openCard, array?.isFirstOffer]);

  const conditionCodeMap = {
    SubtoFin001: {
      Icon: SubFinIcon,
      label: 'Subject to Finance',
    },
    SubtoDep001: {
      Icon: DepIcon,
      label: 'Deposit Amount',
    },
    SubtoCon001: {
      Icon: SubContractIcon,
      label: 'Subject to Contract Review',
    },
    SubtoSettle001: {
      Icon: SettleIcon,
      label: 'Settlement days',
    },
    SubtoDue001: {
      Icon: SubDueDiliIcon,
      label: 'Subject to Due Diligence',
    },
    SubtoAdd001: {
      Icon: AdditionalIcon,
      label: 'Subject to Additional Condition',
    },
  };

  const conditionsToShow = selectedConditionCodes?.map((code) => {
    const condition = conditionCodeMap[code];

    const finalDepositAmount = depAmount ?? depositAmount;
    const finalSettlementDays = settleDays ?? settlementDays;

    if (!condition) return null;

    const isAdditionalCondition = code === 'SubtoAdd001';

    return (
      <AdditionalConditionTooltip
        key={code}
        comment={addictionComment}
        disabled={!isAdditionalCondition}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '15px',
            flex: '1 1 calc(50% - 7.5px)',
            cursor: isAdditionalCondition ? 'pointer' : 'default',
          }}
        >
          {code === 'SubtoDep001' ? (
            <Box sx={{ paddingRight: '5px' }}>
              <condition.Icon depositAmount={finalDepositAmount} />
            </Box>
          ) : code === 'SubtoSettle001' ? (
            <Box sx={{ paddingRight: '5px' }}>
              <condition.Icon settlementDays={finalSettlementDays} />
            </Box>
          ) : (
            <Box sx={{ paddingRight: '5px' }}>
              <condition.Icon />
            </Box>
          )}

          {!matchesmd && (
            <span
              style={{
                fontFamily: 'Poppins',
                fontSize: '12px',
                color: '#666666',
                whiteSpace: 'nowrap',
              }}
            >
              {code === 'SubtoSettle001' && finalSettlementDays !== undefined
                ? `Settlement ${
                    Number(finalSettlementDays) === 1 ? 'day' : 'days'
                  }`
                : condition.label}
            </span>
          )}
        </div>
      </AdditionalConditionTooltip>
    );
  });
  // if (addictionComment) {
  //   conditionsToShow.push(
  //     <div
  //       key="AdditionalCondition"
  //       style={{
  //         display: 'flex',
  //         alignItems: 'center',
  //         gap: '8px',
  //         flex: '1 1 calc(50% - 7.5px)',
  //         marginTop: matchesmd ? -16 : 0,
  //       }}
  //     >
  //       <AdditionalIcon />
  //       {!matchesmd && (
  //         <span
  //           style={{
  //             fontFamily: 'Poppins',
  //             fontSize: '14px',
  //             color: '#666666',
  //             whiteSpace: 'nowrap',
  //           }}
  //         >
  //           Additional Conditions
  //         </span>
  //       )}
  //     </div>
  //   );
  // }

  return (
    <>
      <Dialog
        open={openCard}
        PaperProps={{
          sx: {
            height: 'auto',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchesmd ? '30px 20px' : '30px',
            overflow: 'hidden',
          },
        }}
        zIndex={200000}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchesmd ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            {(isLoading || isLoader) && (
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Pendingwarning matchesmd={matchesmd} />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '16px' : '24px',
                    paddingLeft: '12px',
                    color: '#000000',
                  }}
                >
                  {/* {array?.isFirstOffer == 0 ?  */}
                  Submitting Offer
                  {/* : "Updating Offer"} */}
                </Typography>
              </Grid>
            )}
            {!isLoader && !isLoading && (
              <Grid item display={'flex'} alignItems={'center'}>
                <Warning matchesmd={matchesmd} />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '16px' : '24px',
                    paddingLeft: '12px',
                    color: '#000000',
                  }}
                >
                  <Grid
                    item
                    display={'flex'}
                    alignItems={'center'}
                    padding={'10px 0px'}
                  >
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: matchesmd ? '16px' : '24px',
                        paddingLeft: '8px',
                        color: '#000000',
                      }}
                    >
                      {initialOfferStatus == 0
                        ? 'Offer Submitted Successfully'
                        : 'Offer Updated Successfully'}
                    </Typography>
                  </Grid>
                </Typography>
              </Grid>
            )}
            {(isLoading || isLoader) && (
              <Grid>
                <Typography
                  sx={{
                    paddingTop: '8px',
                    fontFamily: 'poppins!important',
                    fontSize: matchesmd ? '12px' : '16px!important',
                    fontWeight: 400,
                    color: '#666666',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginTop: '0px',
                    justifyItems: 'self-end',
                  }}
                >
                  You{' '}
                  <span>
                    <b
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      {userDetail?.userName} {userDetail?.userSurName}
                    </b>
                  </span>{' '}
                  are submitting an {initialOfferStatus == 0 ? '' : 'updated'}{' '}
                  offer of{' '}
                  <span>
                    <b
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      $
                      {parseFloat(totalAmount).toLocaleString('en-US', {
                        maximumFractionDigits: 2,
                      })}
                    </b>
                  </span>{' '}
                  at &nbsp;
                  <Typography>
                    <b
                      style={{
                        fontFamily: 'Poppins',
                        fontWeight: 550,
                        color: '#666666',
                        fontSize: matchesmd ? '12px' : '16px',
                      }}
                    >
                      {formatDateTimeSydney(currentTime, 'HH:mm:ss')}{' '}
                      {formatDateTimeSydney(currentTime, 'DD-MM-YYYY')}.
                    </b>
                  </Typography>
                </Typography>
              </Grid>
            )}
            {!isLoader && !isLoading && (
              <Grid sx={{ marginTop: '15px' }}>
                <Typography
                  sx={{
                    paddingTop: '8px',
                    fontFamily: 'poppins!important',
                    fontSize: matchesmd ? '12px' : '16px!important',
                    fontWeight: 400,
                    color: '#666666',
                    justifyContent: 'center',
                    alignItems: 'center',

                    marginTop: '0px',
                    justifyItems: 'self-end',
                  }}
                >
                  {makeOfferresponse?.isLowest == 1 &&
                    makeOfferresponse?.message}
                  {makeOfferresponse?.isEqual == 1 &&
                    makeOfferresponse?.message}
                </Typography>
              </Grid>
            )}
            {(isLoading || isLoader) && conditional == true && (
              <Grid
                sx={{ padding: '30px 10px', marginTop: matchesmd ? -2 : 0 }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: 'poppins!important',
                      fontSize: matchesmd ? '12px' : '16px!important',
                      fontWeight: 500,
                      color: '#000000',
                    }}
                  >
                    Selected Preferred Terms
                  </Typography>
                </Grid>
                <Grid
                  item
                  style={{
                    display: 'flex',
                    flexWrap: matchesmd ? 'nowrap' : 'wrap',
                    gap: '15px',
                    marginTop: '20px',
                    justifyContent: matchessm ? 'center' : 'space-between',
                  }}
                >
                  {conditionsToShow.length > 0 ? (
                    conditionsToShow
                  ) : (
                    <div
                      style={{
                        fontFamily: 'Poppins',
                        fontSize: '14px',
                        color: '#666666',
                      }}
                    >
                      No preferred terms
                    </div>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>

          <Grid container>
            <Grid>
              <Typography
                sx={{
                  border: '1px solid #D9D9D9',
                  width: '761px',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  textAlign: 'center',
                  marginTop: '22px',
                  marginLeft: '-28px',
                }}
              ></Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              paddingTop:
                isLoader && matchessm
                  ? ''
                  : isLoading && stage == 'ST2'
                  ? ''
                  : isSmallHeight
                  ? '20px'
                  : '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height:
                isLoading && matchessm
                  ? 'auto'
                  : isLoading && !matchessm
                  ? '309px'
                  : 'auto',
            }}
          >
            {isLoading && stage != 'ST2' && (
              <Spinner isSmallHeight={isSmallHeight} />
            )}{' '}
            {makeOfferresponse?.isLowest != 1 &&
              makeOfferresponse?.isEqual != 1 &&
              showTick && (
                <Sign
                  matchessm={matchessm}
                  isSmallHeight={isSmallHeight}
                  sx={{
                    height: matchessm ? 200 : 309,
                    width: matchessm ? 200 : 309,
                  }}
                />
              )}
          </Grid>
          {isLoading ? (
            <Grid
              container
              gap={2}
              marginTop={
                stage == 'ST2'
                  ? ''
                  : isSmallHeight
                  ? '25px'
                  : matchessm
                  ? '50px'
                  : '60px'
              }
              justifyContent={'end'}
            >
              <Grid item sx={{ marginTop: '8px' }}>
                <DecreasingCounter
                  openBox={openBox}
                  setOpenBox={setOpenBox}
                  setShowTick={setShowTick}
                  setIsLoading={setIsLoading}
                  submitmakeoffer={true}
                  makeOffer={makeOffer}
                  setIsLoader={setIsLoader}
                  stage={stage}
                />
              </Grid>
              {isLoading && stage != 'ST2' && (
                <Grid item>
                  <Button
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchesmd ? '12px' : '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                    onClick={() => {
                      setOpenCard(!openCard);
                      setConfirmCancel(!confirmCancel);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid
              container
              marginTop={matchessm ? '30px' : stage == 'ST2' && '10px'}
              justifyContent={'end'}
            >
              <Grid item>
                <Button
                  disabled={isLoader}
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    marginBottom: matchessm
                      ? ''
                      : stage == 'ST1'
                      ? ''
                      : isLoader && '30px',
                    width: '100%',
                    height: '41px',
                    fontSize: matchesmd ? '12px' : '14px',
                    backgroundColor:
                      makeOfferresponse?.isLowest == 1 ||
                      makeOfferresponse?.isEqual == 1
                        ? '#ffff'
                        : '#4CA4D6',
                    color:
                      makeOfferresponse?.isLowest == 1 ||
                      makeOfferresponse?.isEqual == 1
                        ? '#666666'
                        : '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    borderRadius: '5px',
                    textTransform: 'none',
                  }}
                  onClick={() => {
                    if (!isLoader) {
                      setOpenCard(false);
                      setAcceptterms(false);
                      setOpenBox(false);
                      setIsAutoOffer(false);
                      setTotalAmount(0);
                      setMaximumOffer('');
                      setOfferIncreament('');
                      setSubtoAddSelected(false);
                      // setSelectedConditionCodes([]);
                      // setSelectedItems([]);
                      setShowTick(false);
                      setOffersOnly(false);
                      if (stage != 'ST2' && !isLoader) {
                        setOfferExp(null);
                        setIsBestOffer(false);
                        setIsLoading(true);
                        setIsLoader(false);
                        setShowTick(false);
                        groupIt();
                        groupCall();
                      }
                    }
                  }}
                >
                  {isLoader ? 'Submitting' : 'Close'}
                </Button>
              </Grid>
              {!isLoader &&
                (makeOfferresponse?.isLowest == 1 ||
                  makeOfferresponse?.isEqual == 1) && (
                  <Grid item>
                    <Button
                      disabled={isLoader}
                      variant="outlined"
                      style={{
                        padding: '10px 39px',
                        marginBottom: matchessm
                          ? ''
                          : stage == 'ST1'
                          ? ''
                          : isLoader && '30px',
                        width: '100%',
                        height: '41px',
                        fontSize: matchesmd ? '12px' : '14px',
                        backgroundColor: '#4CA4D6',
                        color: '#FFFFFF',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        borderRadius: '5px',
                        marginLeft: '10px',
                        textTransform: 'none',
                      }}
                      onClick={() => {
                        if (!isLoader) {
                          window.scroll({
                            top: 2000,
                            behavior: 'smooth',
                          });
                          setOpenCard(false);
                          setAcceptterms(false);
                          setOpenBox(false);
                          setIsAutoOffer(false);
                          setTotalAmount(0);
                          setMaximumOffer('');
                          setOfferIncreament('');
                          setSubtoAddSelected(false);
                          setSelectedConditionCodes([]);
                          setSelectedItems([]);
                          setShowTick(false);
                          setOffersOnly(!offersOnly);
                          if (stage != 'ST2' && !isLoader) {
                            setOfferExp(null);
                            setIsBestOffer(false);
                            setIsLoading(true);
                            setIsLoader(false);
                            setShowTick(false);
                            groupIt();
                            groupCall();
                          }
                        }
                      }}
                    >
                      Increase Offer
                    </Button>
                  </Grid>
                )}
              {isLoader && (
                <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img
                    alt="Logo"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '45px', width: '45px' }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Dialog>
    </>
  );
};
export default SubmitOfferPopup;
